import { useContentfulInspectorMode } from '@contentful/live-preview/react';
import type { FC } from 'react';
import { Column } from 'src/components-v2/Layout';
import { Wrapper } from 'src/containers';
import type { DecorativeStatSectionEntry } from 'src/types/contentful';
import DecorativeStat from './DecorativeStat';
import DecorativeStatStepper from './DecorativeStatStepper';

const DecorativeStatSection: FC<DecorativeStatSectionEntry> = ({
  fields: { stats, styles, appearance, layout, mobileAppearance },
  sys,
}) => {
  const inspectorProps = useContentfulInspectorMode({
    entryId: sys.id,
  });

  return (
    <Wrapper
      {...inspectorProps({ fieldId: 'internalTitle' })}
      className='cms-decorative-stat-section'
      sx={styles}
    >
      <Column xs={24} lg={20} lgOffset={2}>
        <DecorativeStatStepper
          appearance={appearance}
          mobileAppearance={mobileAppearance}
        >
          {stats.map((stat, index) => {
            return (
              <DecorativeStat
                key={`${stat.sys.id}-${index}`}
                {...stat}
                layout={layout}
                appearance={appearance}
                mobileAppearance={mobileAppearance}
              />
            );
          })}
        </DecorativeStatStepper>
      </Column>
    </Wrapper>
  );
};

export default DecorativeStatSection;
